import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useLoaderStore = defineStore('loader', () => {
	const isLoading = ref<boolean>(false);

	function setLoading(status: boolean) {
		isLoading.value = status;
	}

	return { isLoading, setLoading };
});
